import type { TAppConfig } from "~ui/@application/configs/config-schema.ts";
import type { TServices } from "~ui/@application/di.ts";

import { type App, inject, type Plugin } from "vue";

const CONFIG_KEY = Symbol("app-config");
const SERVICES_KEY = Symbol("app-services");

export const provideConfigPlugin = {
  install(app: App, options: { config: TAppConfig }) {
    const { config } = options;
    app.provide<TAppConfig>(CONFIG_KEY, config);
  },
} satisfies Plugin;

export const provideServicesPlugin = {
  async install(app: App, options: { services: TServices }) {
    app.provide<TServices>(SERVICES_KEY, options.services);
  },
} satisfies Plugin;

export function useConfig(): TAppConfig {
  const cfg = inject<TAppConfig>(CONFIG_KEY);
  if (!cfg) {
    throw new Error("Config not provided");
  }

  return cfg;
}

export function useServices(): TServices {
  const services = inject<TServices>(SERVICES_KEY);
  if (!services) {
    throw new Error("Services not provided");
  }

  return services;
}
